import { render, staticRenderFns } from "./mgVxeColumn.vue?vue&type=template&id=f5818ad0&scoped=true"
import script from "./mgVxeColumn.vue?vue&type=script&lang=js"
export * from "./mgVxeColumn.vue?vue&type=script&lang=js"
import style0 from "./mgVxeColumn.vue?vue&type=style&index=0&id=f5818ad0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5818ad0",
  null
  
)

export default component.exports